import React from 'react'

const PricingSection = () => {
  // Handle navigation to app subdomain
  const navigateToApp = (path = '') => {
    // In production, this will navigate to app.echoinbox.ai
    // In development, we'll use a relative path
    const isProduction = process.env.NODE_ENV === 'production'
    const appDomain = isProduction ? 'https://app.echoinbox.ai' : ''
    window.location.href = `${appDomain}${path}`
  }

  return (
    <section className="pricing-section" id="pricing">
      <div className="container">
        <div className="section-header">
          <div className="section-tag">Pricing</div>
          <h2>
            Simple <span className="text-gradient">Pricing</span> for Everyone
          </h2>
          <p>Start managing your emails more efficiently with EchoInbox</p>
        </div>

        <div className="pricing-tiers single-plan">
          <div className="pricing-tier featured">
            <h2>Pro Plan</h2>
            <p className="price">
              $19.99<span>/month</span>
            </p>
            <ul className="features">
              <li>Unlimited email processing</li>
              <li>Premium AI responses</li>
              <li>Gmail & Outlook integration</li>
              <li>Unlimited response history</li>
              <li>24/7 priority support</li>
              <li>Advanced analytics</li>
              <li>Custom email templates</li>
              <li>Priority email processing</li>
            </ul>
            <button className="btn btn-primary" onClick={() => navigateToApp('/subscribe/pro')}>
              Get Started
            </button>
          </div>
        </div>

        <div className="pricing-faq">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-item">
            <h3>Is there a free trial?</h3>
            <p>
              Yes, our Pro plan comes with a 14-day free trial. No credit card required until you
              decide to continue.
            </p>
          </div>
          <div className="faq-item">
            <h3>What happens after the free trial?</h3>
            <p>
              After your 14-day free trial, you'll be prompted to enter your payment details to
              continue using EchoInbox. You can cancel anytime before the trial ends if you decide
              not to continue.
            </p>
          </div>
          <div className="faq-item">
            <h3>How do I cancel my subscription?</h3>
            <p>
              You can cancel your subscription at any time from your account settings. You'll
              continue to have access until the end of your current billing period.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PricingSection
